import React, { Component } from 'react'
import { Box, CircularProgress, Fade, alpha, styled } from '@mui/material'

interface IOverlayLazy {
  in?: boolean
}
export default class OverlayLazy extends Component<IOverlayLazy> {
  render() {
    return (
      <Fade in={this.props.in}>
        <AbsoluteBox>
          <CircularProgress size='24px' />
        </AbsoluteBox>
      </Fade>
    )
  }
}

const AbsoluteBox = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  borderRadius: '4px',
  backgroundColor: alpha('#fff', 0.5),
  paddingRight: '12px'
})
